import { TableColumn } from "react-data-table-component";
import { IConfig, IUser } from "src/services/types";
import { X, Check, Eye} from 'feather-icons-react';
import { DropdownActionsUser } from "../Users/DropdownActionsUser";
import { UserColumnItem } from "../Users/UserColumnItem";

export const columnsUsersToValidate: (
    config: IConfig,
    activeSelected: boolean,
    selectedRows: IUser[],
    onValidate: (item: IUser) => void,
    onReject: (item: IUser) => void,
    openModal: (item: IUser) => void,
    onDelete: (item: IUser) => void,
    onMoveAGroup: (item: IUser) => void,
    openNoteModal: (item: IUser) => void,
    openEditUserModal: (item: IUser) => void,
    onSelectUser: (item: IUser) => void
) => TableColumn<IUser>[] = 
(config, activeSelected, selectedRows, onValidate, onReject, openModal, onDelete, onMoveAGroup, openNoteModal, openEditUserModal, onSelectUser) => {

    return (
[
    activeSelected ? 
    {
      name: "",
      width: "50px",
      center: true,
      cell: function OrderItems(item) {
        return (
          <div>
            <input 
              type="checkbox" 
              name={`user_${item.id}`} 
              onChange={() => onSelectUser(item)}
              checked={ selectedRows.some(selected => selected.id === item.id)}
              style={{ width: '20px', height: '20px', accentColor: '#57995a' }}
            />
          </div>
        );
      }
    } : {
      width: "0px",
    },
    { 
      name: "N°",
      width: "80px",
      center: true,
      selector: (_, index, ) => (config.page-1)*config.per_page + (index! + 1),
    },
    {
      name: "USER",
      width: "180px",
      cell: function OrderItems(item) {
        return (
          <UserColumnItem
            item={item}
            openModal={openModal}
            openNoteModal={openNoteModal}
          />
        );
      }
    },
    {
      name: "EMAIL",
      width: "300px",
      selector: (row: IUser) => row.email,
    },
    {
      name: "GROUP",
      width: "110px",
      center: true,
      cell: function OrderItems(item) {
        return (
          <>
            {
              item?.group ? (
                <small
                    className="p-2 rounded"
                    style={{ backgroundColor: item?.group?.color || '#f5f5f5'}}
                >
                  <span>{item?.group?.name ? (item.group.name.length > 10 ? item.group.name.slice(0, 9) + '...' : item.group.name) : '-'}</span>
                </small>
              ) : '-'
            }
          </>
        );
      },
    },
    {
      name: "CREATED AT",
      width: "105px",
      selector: (row: IUser) => row.created_at,
    },
    {
      name: "PLAID",
      center: true,
      width: "110px",
      cell: function OrderItems(item) {
          return (
              <button
                  type="button"
                  className="btn btn-soft-info btn-sm"
                  onClick={(e) => (openModal(item), e.currentTarget.blur())}
              >
                <span>Show info </span>
                <Eye size="16"/>
              </button>
          );
      },
    },
    {
      name: "VALIDATE USER",
      center: true,
      width: "125px",
      cell: function OrderItems(item) {
          return (
              <button
                  type="button"
                  className="btn btn-soft-success btn-sm waves-effect waves-light"
                  onClick={(e) => (onValidate(item), e.currentTarget.blur())}
              >
                <span>Validate user </span>
                <Check size="16"/>
              </button>
          );
      },
    },
    {
      name: "REJECT USER",
      center: true,
      width: "125px",
      cell: function OrderItems(item) {
          return (
              <button
                  type="button"
                  className="btn btn-soft-danger btn-sm waves-effect waves-light"
                  onClick={(e) => (onReject(item), e.currentTarget.blur())}
              >
                <span>Reject user </span>
                <X size="16"/>
              </button>
          );
      },
    },
    {
      name: "OPTIONS",
      width: "100px",
      center: true,
      cell: function OrderItems(item) {
        return (
          <DropdownActionsUser 
            item={item}
            openNoteModal={openNoteModal}
            onMoveAGroup={onMoveAGroup}
            openEditUserModal={openEditUserModal}
            onDelete={onDelete}
          />
        );
      }
    }
   
  ]
)}